const Colors = {
  bgBlue: 'linear-gradient(90.13deg, #1567B1 0%, #2679BF 100%)',
  bgRed: 'linear-gradient(90.13deg, #EA4437 0%, #F95E5E 100%)',
  bgGrey: 'linear-gradient(90.13deg, #58646C 0%, #666666 100%)',
  blueShadow: '5px 5px 25px rgba(43, 129, 199, 0.4), inset 5px 5px 25px rgba(52, 143, 218, 0.7)',
  redShadow: '5px 5px 25px rgba(234, 68, 54, 0.4), inset 0px 25px 50px rgba(253, 145, 136, 0.5)',
}

export default Colors
